import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
// import Checkout from '../../components/payment/Checkout';
import logo from '../../assets/logo.svg';
import paymentSuccess from '../../assets/payment-success.svg';
import paymentFailed from '../../assets/payment-failed.svg';
// import delectable from '../../assets/delectable.svg';
import welcomeRight from '../../assets/welcome_right.png';
import PaymentForm from '../../components/payment-card/PaymentForm';
import Footer from '../../components/footer/Footer';
import LanguageDropdown from '../../components/Language-Dropdown/LanguageDropdown';
import { paymentStep, setUserPaymentDetails, setVerifySlugStatus, verifySlug } from '../../redux/payment/actions';
import Loader from '../../components/loader/Loader';
import Checkout from '../../components/payment/Checkout';
import { selectLanguage } from '../../redux/authentication/actions';

function Pay() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loaderStatus = useSelector((state) => state.loader.pageLoader);
  const businessData = useSelector((state) => state.payment.businessData);
  const paymentStepCount = useSelector((state) => state.payment.paymentStep);
  const paymentStatus = useSelector((state) => state.payment.paymentStatus);
  const verifySlugStatus = useSelector((state) => state.payment.verifySlugStatus);
  const language = useSelector((state) => state?.auth?.language);
  const storedLang = localStorage.getItem('setLang');

  const { id } = useParams();
  const [step, setStep] = useState(1);

  useEffect(() => {
    if (language?.length < 0 || language?.length === undefined) {
      dispatch(selectLanguage(storedLang || 'ita'));
    }
  }, []);

  useEffect(() => {
    setStep(paymentStepCount);
  }, [paymentStepCount]);
  useEffect(() => {
    setStep(paymentStepCount);
  }, [paymentStepCount]);

  useEffect(() => {
    localStorage.setItem('slug', id);
    const slug = id;
    dispatch(verifySlug(slug));
    dispatch(paymentStep(1));
    dispatch(setUserPaymentDetails());
  }, []);

  useEffect(() => {
    if (!verifySlugStatus) {
      navigate('/invalid-slug');
    }
  }, [verifySlugStatus]);

  useEffect(() => {
    dispatch(setVerifySlugStatus(true));
  }, []);

  return (
    <>
      {loaderStatus && <Loader />}
      <div className="main_section h-full bg_icon bg-mobile-view">
        <div className="container px-only-md-2 box-alignment">
          <div className="w-100 pt-3 mb-3" style={{ zIndex: '9992' }}>
            <Row gutter={[16, 16]}>
              <Col xs={0} md={4} style={{ padding: '0px', margin: '0px' }} />
              <Col xs={12} md={15}>
                <div className="text-md-center logo-size">
                  <img src={logo} alt="logo" width={245} height={60} />
                </div>
              </Col>
              <Col xs={12} md={5} className="btn-hide-hove">
                <LanguageDropdown />
              </Col>
            </Row>
          </div>
          {step !== 3 && (
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <div className="pt-2">
                  <div className="flex align-items-center">
                    <div className="business-logo-size">
                      <img src={businessData?.logo} alt="delectable" className="business-logo" />
                    </div>
                    <p className="mb-0 ps-1 title-banner">{businessData?.business_name}</p>
                  </div>
                  <h1 className="mb-0 py-2 payment-card-title">{language?.content?.MAKE_A_PAYMENT}</h1>
                  <div>
                    {step === 1 ? (
                      <PaymentForm
                        language={language}
                        businessData={businessData}
                        btnColour={businessData?.colour}
                        slug={id}
                      />
                    ) : step === 2 ? (
                      <Checkout />
                    ) : // <KlarnaCheckout />
                    null}
                  </div>
                </div>
              </Col>
              <Col xs={24} md={12} className="hide-md align-self-center">
                <div className="mx-auto welcome-img-size">
                  <img src={welcomeRight} alt="banner-right-img" className="img-fluid" />
                </div>
              </Col>
            </Row>
          )}
          {!loaderStatus && step === 3 && (
            <Row gutter={[16, 16]}>
              <Col xs={24} md={8} lg={6} className="align-self-center mx-auto text-center">
                <div className="mx-auto">
                  {paymentStatus ? (
                    <>
                      <img src={paymentSuccess} alt="paymentSuccess img" className="img-fluid" />
                      <div className="color-success payment-status-text">{language?.content?.PAYMENT_SUCCESS}</div>
                    </>
                  ) : (
                    <>
                      <img src={paymentFailed} alt="paymentFailed img" className="img-fluid" />
                      <div className="color-danger payment-status-text">{language?.content?.PAYMENT_FAIL}</div>
                    </>
                  )}
                </div>
                <div className="pt-3">
                  <a href={`/pay/${id}`} style={{ fontSize: '16px', color: '#007DFC', fontWeight: '600' }}>
                    {language?.content?.BACK_TO_HOME || 'Back to home'}
                  </a>
                </div>
              </Col>
            </Row>
          )}
          <div className="py-2" style={{ marginLeft: '-8px', marginRight: '-8px' }}>
            <Footer language={language} />
          </div>
        </div>
      </div>
    </>
  );
}

export default Pay;
